export default __webpack_public_path__ + "assets/cb_iss.6eee744a.png";